import { styled } from 'theme';
import { sizes } from 'theme/constants';

const Container = styled('div', {
  // Reset
  boxSizing: 'border-box',
  flexShrink: 0,

  // Custom
  position: 'relative',
  mx: 'auto',
  maxWidth: '1296px',

  variants: {
    variant: {
      main: {
        minHeight: `calc(100vh - ${sizes.topBarHeight}px)`,
        p: '$6',
        pb: '$24',
        '@lg': {
          px: '$20',
          pt: '$10',
        },
      },
    },
  },
});

export default Container;
